import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Textarea,
} from '@chakra-ui/react'
import { AiFillEye } from 'react-icons/ai'

export function VisualizarSolucao({ solucao }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Button onClick={onOpen}>
        <AiFillEye size={20} />
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Solução:</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Textarea
              value={solucao}
              readOnly
              placeholder="Solução"
              size="sm"
              resize="none"
              h="150px"
              w="100%"
              overflow="auto"
              border="none"
              _hover={{ border: 'none' }}
              _focus={{ border: 'none' }}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
